import HelperMixin from '../../Shared/HelperMixin.vue';

export default {
    name: 'WorkflowDefinitions',
    mixins: [HelperMixin],

    computed: {
        statsCards() {
            return [
                this.statCard('إجمالي التعريفات', this.info.length, 'primary', 'ti ti-git-branch'),
                this.statCard('تعريفات مخصصة', this.countWhere(this.info, item => !!item.isConfigured), 'warning', 'ti ti-adjustments'),
                this.statCard('تعريفات مفعلة', this.countWhere(this.info, item => item.isActive !== false), 'success', 'ti ti-circle-check'),
                this.statCard('إجمالي خطوات الاعتماد', this.sumWhere(this.info, item => Array.isArray(item.steps) ? item.steps.length : 0), 'info', 'ti ti-list-numbers'),
            ];
        }
    },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canManageWorkflowDefinitionsUi()) {
            this.logout();
            return;
        }
        this.loadInfo();
    },

    data() {
        return {
            info: [],
            roles: [],
            editDialog: false,
            form: {
                entityType: '',
                name: '',
                note: '',
                isActive: true,
                steps: []
            }
        };
    },

    methods: {
        loadInfo() {
            this.$blockUI.Start();
            this.$http.GetWorkflowDefinitions()
                .then((response) => {
                    this.$blockUI.Stop();
                    this.info = response.data.info || [];
                    this.roles = response.data.roles || [];
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.info = [];
                    this.roles = [];
                });
        },
        openEdit(item) {
            this.$blockUI.Start();
            this.$http.GetWorkflowDefinition(item.entityType)
                .then((response) => {
                    this.$blockUI.Stop();
                    const info = response.data.info || {};
                    this.form = {
                        entityType: info.entityType,
                        name: info.name || '',
                        note: info.note || '',
                        isActive: info.isActive !== false,
                        steps: (info.steps || []).map((step, index) => ({
                            stepNo: Number(step.stepNo || index + 1),
                            stepName: step.stepName || `الخطوة ${index + 1}`,
                            requiredRole: step.requiredRole || ''
                        }))
                    };
                    this.editDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        addStep() {
            this.form.steps.push({
                stepNo: this.form.steps.length + 1,
                stepName: `الخطوة ${this.form.steps.length + 1}`,
                requiredRole: this.roles.length ? this.roles[0].id : ''
            });
        },
        removeStep(index) {
            this.form.steps.splice(index, 1);
            this.form.steps.forEach((step, idx) => { step.stepNo = idx + 1; });
        },
        save() {
            if (!this.form.entityType || !this.form.steps.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'أضف خطوة اعتماد واحدة على الأقل.');
                return;
            }
            this.$blockUI.Start();
            this.$http.SaveWorkflowDefinition(this.form)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.editDialog = false;
                    this.loadInfo();
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        }
    }
};
